import { render, staticRenderFns } from "./LooseThread.vue?vue&type=template&id=baee6f52&scoped=true&"
import script from "./LooseThread.vue?vue&type=script&lang=js&"
export * from "./LooseThread.vue?vue&type=script&lang=js&"
import style0 from "./LooseThread.vue?vue&type=style&index=0&id=baee6f52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baee6f52",
  null
  
)

export default component.exports